export enum BrandingImageType {
  LOGO = 'logo',
  ISO = 'iso',
}

export interface BrandingImageProps {
  type: BrandingImageType;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
  preview?: boolean;
}
